import React, { Component } from 'react';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isNull from 'lodash/isNull';
import orderBy from 'lodash/orderBy';
import findIndex from 'lodash/findIndex';
import { connect } from 'react-redux';
import styled from 'styled-components';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import InfiniteScroll from 'react-infinite-scroller';
import Axios from 'axios';
import { authManager, episodeManager, soundcastManager, userManager, publisherManager } from '../../helpers/managers';
import { LoadingContainer, FullContentWrapper, FullContentSection } from '../../styles/styled';
import Loading from '../../components/Loading';
import Footer from '../../components/footer';
import { SoundwiseHeader } from '../../components/soundwise_header';
import AudioPlayer from 'react-responsive-audio-player';
import EpisodePreview from './components/episode_preview';
import { assignTrackUrlToken } from '../../helpers/episodeTrack';
const { extractPublisherIAPHubDetails } = require('../../../server/scripts/utils')();

class SoundcastPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soundcast: {},
      soundcastID: '',
      noAccess: false,
      playlist: [],
      episodes: [],
      likes: [],
      currentEpisode: null,
      playing: false,
      paused: true,
      ended: true,
      playerLaunched: false,
      episodeLoading: '',
      startPosition: 0,
      endPosition: 0,
      soundcastAvailable: false,
      verifyingAccess: false,
      renderReady: false,
      totalEpisodes: 0,
    };

    this.audio = null;
    this.episodes = [];
    this.onEpisodePlay = this.onEpisodePlay.bind(this);
    this.onEpisodeLike = this.onEpisodeLike.bind(this);
    this.recordPlaying = this.recordPlaying.bind(this);
    this.handlePause = this.handlePause.bind(this);
    this.handleEpisodeEnd = this.handleEpisodeEnd.bind(this);
    this.loadMorePaginatedEpisodes = this.loadMorePaginatedEpisodes.bind(this);
  }

  componentDidMount() {
    authManager.onAuthStateChanged(user => {
      if (user) {
        // load soundcast data
        this.loadSoundcastEpisodes();
      } else {
        this.props.history.push('/signin');
      }
    });
  }

  componentWillReceiveProps(_nextProps) {
    const { soundcastAvailable, renderReady } = this.state;
    if (!soundcastAvailable && !renderReady) {
      this.loadSoundcastEpisodes();
    }
  }

  fetchedLikedEpisodesByCurrentUser() {
    return new Promise(async resolve => {
      try {
        const { userInfo, match } = this.props;
        const { soundcastId } = match.params;
        const { data } = await Axios.get('/api/likes', {
          params: {
            filter: {
              where: {
                userId: userInfo.id,
                soundcastId,
                announcementId: null,
                commentId: null,
              },
            },
          },
        });

        resolve(data);
      } catch (err) {
        resolve([]);
      }
    });
  }

  loadDripEpisodes() {
    return new Promise(async (resolve, reject) => {
      try {
        const { userInfo, match } = this.props;
        const { soundcastId } = match.params;
        const url = `/api/user/${userInfo.id}/episodes/${soundcastId}/drip`;
        const { data: episodes = [] } = await Axios.get(url);
        resolve(orderBy(episodes, ['index'], ['desc']));
      } catch (err) {
        reject(err);
      }
    });
  }

  loadEpisodesFromFirebase() {
    return new Promise(async (mresolve, mreject) => {
      try {
        const { match } = this.props;
        const { soundcastId } = match.params;

        const episodeIds = await new Promise(async resolve => {
          try {
            const episodes = await soundcastManager.getProp(soundcastId, 'episodes');
            if (isNull(episodes)) {
              throw new Error('Audio program has no valid tracks');
            }
            resolve(Object.keys(episodes));
          } catch (err) {
            resolve([]);
          }
        });

        if (isEmpty(episodeIds)) {
          return mresolve([]);
        }

        const episodesRequest = episodeIds.map(episodeId => {
          return new Promise(async resolve => {
            try {
              await new Promise(r => setTimeout(r, 1000));

              const episode = await episodeManager.getById(episodeId);
              if (isNull(episode)) {
                throw new Error(`Track ${episodeId} does not exist`);
              }

              resolve({
                episodeId,
                ...episode,
              });
            } catch (err) {
              console.error(err);
              resolve({});
            }
          });
        });

        const result = await Promise.all(episodesRequest);
        const filtered = result.filter(episode => !isEmpty(episode));
        const episodes = orderBy([...filtered], ['index'], ['desc'])
          .filter(episode => episode.published || episode.isPublished)
          .map(episode => {
            if (!episode.published){
              episode.published = episode.isPublished;
            }
            return episode;
          });

        mresolve(episodes);
      } catch (err) {
        mreject(err);
      }
    });
  }

  loadPaginatedEpisodes(page = 1) {
    return new Promise(async (resolve, reject) => {
      try {
        const { match } = this.props;
        const { soundcastId } = match.params;
        const limit = 100;
        const offset = (page - 1) * limit;
        const url = `/api/soundcast/${soundcastId}/episodes`;
        const { status, data } = await Axios.get(url, {
          params: {
            offset,
            limit,
            total: true,
            filter: { where: { published: true }, order: [['index', 'DESC'],['episodeId', 'DESC']] },
          },
        });

        if (status === 200) {
          const { data: episodes, total } = data;
          resolve([episodes, total]);
        } else {
          throw new Error(`Unable to retrieve tracks with unknown status ${status}`);
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  async loadMorePaginatedEpisodes(page = 1) {
    try {
      const [newEpisodes, total] = await this.loadPaginatedEpisodes(page);
      this.setState(({ episodes: oldEpisodes }) => {
        return {
          episodes: [...oldEpisodes, ...newEpisodes],
          total,
        };
      });
    } catch (err) {
      console.log('Error retrieving tracks', err.message);
    }
  }

  hasMorePaginatedEpisodes() {
    const { episodes, totalEpisodes } = this.state;
    return totalEpisodes > episodes.length;
  }

  renderPaginatedEpisodesLoader() {
    return (
      <EpisodesLoader key={0}>
        <Loading align="center" size={40} fontSize={1.6} text="Loading tracks" />
      </EpisodesLoader>
    );
  }

  isSoundcastAccessValid(userID, soundcastId) {
    return new Promise(async resolve => {
      try {
        const subscription = await userManager.getProp(userID, `soundcasts/${soundcastId}`, {});
        const { current_period_end = 0, bundleId = '' } = subscription;
        let accessPeriodEnd = current_period_end;

        // If the soundcast is part of a bundle, then availability is determined by that bundle.
        if (!isEmpty(bundleId)) {
          const bundlePeperiodEnd = await userManager.getProp(
            userID,
            `soundcasts/${bundleId}/current_period_end`,
            0
          );
          if (bundlePeperiodEnd > accessPeriodEnd) {
            accessPeriodEnd = bundlePeperiodEnd;
          }
        }

        const accessValid = moment.unix(accessPeriodEnd) > moment();
        resolve(accessValid);
      } catch (e) {
        console.error(e);
        resolve(false);
      }
    });
  }

  async loadSoundcastEpisodes() {
    const { userInfo, match } = this.props;
    const { soundcastId } = match.params;

    // check if its a true user object
    if (!userInfo.id) {
      return false;
    }

    // #654 - load soundcast and its episode from here until its not in cache yet
    const soundcast = await new Promise(async resolve => {
      const nsoundcast = await soundcastManager.getById(soundcastId);
      if (isNull(nsoundcast)) {
        return resolve({});
      }
      resolve({ ...nsoundcast });
    });

    // make sure soundcast is already there
    // or in verification state
    if (isEmpty(soundcast) || this.state.verifyingAccess) {
      return false;
    }

    const { type: soundcastType = 'general', transition } = soundcast;
    this.setState({ verifyingAccess: true }, async () => {
      // check if the current access to this soundcast, has been expired
      const accessible = await this.isSoundcastAccessValid(userInfo.id, soundcastId);
      if (!accessible) {
        // show no access
        return this.setState({
          noAccess: true,
          soundcastAvailable: true,
          verifyingAccess: false,
          renderReady: true,
        });
      }

      // check listener access mode for paid or private soundcasts
      const { publisherID, forSale, published, landingPage } = soundcast;
      if (forSale || (published && !landingPage)) {
        const onlyMobileAccessToTracks = await publisherManager.getProp(publisherID, 'onlyMobileAccessToTracks', false);
        if (onlyMobileAccessToTracks) {
          const publisher = await publisherManager.getById(publisherID);
          const publisherIAPHubDetails = extractPublisherIAPHubDetails(publisher);
          return this.setState({
            onlyMobileAccessToTracks,
            publisherIAPHubDetails,
            soundcast,
            soundcastID: soundcastId,
            noAccess: false,
            soundcastAvailable: true,
            verifyingAccess: false,
            renderReady: true,
          });
        }
      }

      // load initial episode data
      // - for drip episodes, just load every episodes from api
      // - for normal episode, load in a paginated manner
      // and at the same time, load the soundcast episodes like
      const [episodesSet, likes] = await Promise.all([
        new Promise(async resolve => {
          try {
            // if soundcast is drip, pull the episodes from endpoint
            if (soundcastType === 'drip') {
              const dripEpisodes = await this.loadDripEpisodes();
              return resolve([dripEpisodes, dripEpisodes.length]);
            }

            // if the soundcast has never been transitioned
            // load the episodes from firebase
            // fetch conditions from postgresql and from firebase must be the equivalent
            if (transition !== 'completed') {
              const firebaseEpisodes = await this.loadEpisodesFromFirebase();
              return resolve([firebaseEpisodes, firebaseEpisodes.length]);
            }

            // normal episodes
            const resultSet = await this.loadPaginatedEpisodes();
            resolve(resultSet);
          } catch (err) {
            resolve([]);
          }
        }),

        new Promise(async resolve => {
          try {
            // get episode likes and set to state
            const likesObj = await this.fetchedLikedEpisodesByCurrentUser();
            const likes = !isEmpty(likesObj)
              ? likesObj.map(like => {
                  return like.episodeId;
                })
              : [];

            resolve(likes);
          } catch (err) {
            resolve([]);
          }
        }),
      ]);

      const disableTracksAttachedContent = await publisherManager.getProp(publisherID, 'disableTracksAttachedContent', false);

      // put episodes to cache somewhere
      const [episodes, totalEpisodes] = episodesSet;
      return this.setState({
        episodes,
        totalEpisodes,
        likes,
        soundcast,
        soundcastID: soundcastId,
        noAccess: false,
        soundcastAvailable: true,
        verifyingAccess: false,
        renderReady: true,
        disableTracksAttachedContent,
      });
    });
  }

  async sendToDatabase(event, currentEpisode) {
    const { userInfo } = this.props;
    const { soundcastID, soundcast, startPosition } = this.state;
    let totalListens = currentEpisode.totalListens ? currentEpisode.totalListens : 0;

    await episodeManager.saveProp(currentEpisode.episodeId, 'totalListens', totalListens + 1);

    const { currentTime = 0, duration: audioDuration = 0 } = this.audio || {};
    const { duration: episodeDuration } = currentEpisode || {};
    const duration = episodeDuration || audioDuration || 0;
    const endPosition = await new Promise(resolve => {
      if (event === 'pause') {
        resolve(currentTime);
      } else if (event === 'ended') {
        resolve(duration);
      }

      resolve(0);
    });

    this.setState({ endPosition }, async () => {
      const sessionDuration = endPosition - startPosition;
      if (sessionDuration > 0) {
        // save only with positive duration
        try {
          const _date = moment().format('YYYY-MM-DD');
          await Axios.post('/api/listeningSessions', {
            soundcastId: soundcastID,
            publisherId: soundcast.publisherID,
            episodeId: currentEpisode.episodeId,
            userId: userInfo.id,
            date: _date,
            startPosition: Math.floor(startPosition),
            endPosition: Math.ceil(endPosition >= startPosition ? endPosition : startPosition),
            percentCompleted: Math.ceil((endPosition / duration) * 100 || 100),
            sessionDuration: Math.ceil(sessionDuration),
            createdAt: _date,
            updatedAt: _date,
          });
        } catch (err) {
          console.log(err.message);
        }
      }
    });
  }

  getTime_hoursMins(seconds) {
    if (seconds > 0) {
      const _hours = Math.floor(seconds / 3600);
      const _minutes = Math.floor((seconds - _hours * 3600) / 60);
      return `${(_hours && `${_hours} hour`) || ''}${(_hours > 1 && 's') || ''} ${
        (_minutes < 10 && `0${_minutes} min`) || `${_minutes} min`
      }${(_minutes > 1 && 's') || ''}`;
    } else {
      return '0 mins';
    }
  }

  recordPlaying() {
    if (this.audio) {
      this.setState({
        startPosition: this.audio.currentTime,
        playing: true,
        paused: false,
        ended: false,
      });
    }
  }

  nativePlay() {
    // https://developers.google.com/web/updates/2016/03/play-returns-promise?hl=en
    const playPromise = this.audio.play();

    // In browsers that don’t yet support this functionality, playPromise won’t be defined.
    if (playPromise !== undefined) {
      return playPromise;
    }

    return Promise.resolve();
  }

  onEpisodePlay(episode) {
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const { currentEpisode = {}, playing, paused, ended } = this.state;
    const { episodeId: currentEpisodeId } = currentEpisode || {};
    const isTheSameEpisode = isEqual(currentEpisodeId, episode.episodeId);

    // pause if playing the same episode
    if (playing) {
      this.audio.pause();

      if (isTheSameEpisode) {
        return;
      }
    }

    // play if paused the same episode and not ended
    if (paused && !ended && isTheSameEpisode) {
      return this.nativePlay();
    }

    this.setState({ episodeLoading: episode.episodeId }, async () => {
      const episodeUrl = await assignTrackUrlToken(episode);
      this.setState(
        {
          currentEpisode: episode,
          playlist: [
            {
              url: episodeUrl,
              displayText: episode.title,
            },
          ],
        },
        () => {
          this.audio.preload = 'auto';
          this.audio.src = episodeUrl;
          if (iOS) {
            // canplay event is not supported on iOS devices, use loadedmetadata instead
            this.audio.onloadedmetadata = () => {
              // console.log(`soundcast_playing_page: loadedmetadata callback`);
              this.nativePlay().then(() => {
                setTimeout(() => this.nativePlay(), 1000); // hack for first track played
                this.setState({
                  playerLaunched: true,
                });
              });
            }; 
          } else {
            this.audio.oncanplay = () => {
              // console.log('soundcast_playing_page: canplay callback');
              this.nativePlay().then(() => {
                this.setState({
                  playerLaunched: true,
                });
              });
            };
          }

          this.audio.onloadeddata = () => {
            this.setState({
              episodeLoading: '',
            });
          };
        }
      );
    });
  }

  onEpisodeLike(episode) {
    const { episodeId, likesCount = 0 } = episode;
    const { userInfo } = this.props;
    const { soundcastID, likes, episodes } = this.state;

    // if there's a user use it as the likeId
    const likeId = `${userInfo.id}-${episodeId}`;
    const likerId = userInfo.id;
    const fullName = `${userInfo.firstName} ${userInfo.lastName}`;
    const liked = likes.includes(episodeId);

    // update like count
    let updatedLikesCount = likesCount;
    const updatedLikes = [...likes];
    if (!liked) {
      updatedLikes.push(episodeId);
      updatedLikesCount += 1;
    } else {
      const likedIndex = likes.indexOf(episodeId);
      updatedLikes.splice(likedIndex, 1);

      const updatedCount = updatedLikesCount - 1;
      updatedLikesCount = updatedCount > 0 ? updatedCount : 0;
    }

    // update episodes state
    const updatedEpisodes = episodes.map(oldepisode => {
      if (isEqual(oldepisode.episodeId, episodeId)) {
        oldepisode.likesCount = updatedLikesCount;
      }

      return oldepisode;
    });

    this.setState({ episodes: updatedEpisodes, likes: updatedLikes }, () => {
      // update like count
      if (!liked) {
        Axios.post('/api/likes', {
          likeId,
          userId: likerId,
          fullName,
          episodeId,
          soundcastId: soundcastID,
          timeStamp: moment().format('X'),
        })
          .then(() => console.log('success set like'))
          .catch(err => alert('ERROR: like save: ' + err.toString()));
      } else {
        Axios.delete(`/api/likes/${likeId}`)
          .then(() => console.log('success delete like'))
          .catch(err => alert('ERROR: like delete: ' + err.toString()));
      }
    });
  }

  handleEpisodeEnd() {
    const { currentEpisode, episodes } = this.state;
    this.sendToDatabase('ended', currentEpisode);
    this.setState({ playing: false, paused: true, ended: true }, () => {
      const currentIndex = findIndex(episodes, e => isEqual(e.episodeId, currentEpisode.episodeId));
      // reached the last episode in soundcast
      if (currentIndex === episodes.length - 1) {
        return false;
      }

      // play next track
      const nextIndex = currentIndex + 1;
      if (nextIndex <= episodes.length - 1) {
        this.onEpisodePlay(episodes[nextIndex]);
      }
    });
  }

  handlePause() {
    this.sendToDatabase('pause', this.state.currentEpisode);
    this.setState({
      playing: false,
      paused: true,
    });
  }

  renderNoAccess() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 text-center">
            <h2 className="section-title-large sm-section-title-medium xs-section-title-large text-dark-gray font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text">
              {`Oops, it looks like you don't have access to this page :(`}
            </h2>
          </div>
        </div>
      </div>
    );
  }

  renderMobileAccess() {
    const {
      appName,
      playstoreUrl,
      appstoreUrl,
    } = this.state.publisherIAPHubDetails;

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 text-center">

            <div style={{ lineHeight: '150%' }}>
              <div className="col-md-8 col-sm-9 col-xs-12 center-col text-center">
                <div className="section-title-small" style={{ marginBottom: 15 }}>
                  <span>
                    <strong>According to the requirements of the content owner, </strong>
                    <strong>listening to the tracks of this soundcast is only possible from mobile applications.</strong>
                  </span>
                </div>
                <div className="text-large">
                  <span>
                    <strong>Step 1: </strong>
                  </span>
                  <span>Download the {appName} app</span>
                </div>
                <div className="width-100 text-center">
                  <a
                    href={appstoreUrl}
                    target="_blank"
                    className="xs-width-150px display-inline-block margin-two">
                    <img
                      alt="Download soundwise podcast iOS mobile application on App store"
                      style={{ width: 175 }}
                      src="../images/app-store-badge.png"
                      data-img-size="(W)175px X (H)51px"
                    />
                  </a>
                  <a
                    href={playstoreUrl}
                    target="_blank"
                    className="xs-width-150px display-inline-block margin-two">
                    <img
                      src="../images/google-play-badge.png"
                      data-img-size="(W)200px X (H)61px"
                      style={{ width: 175 }}
                      alt="Download soundwise podcast Android mobile application on Google play Store"
                    />
                  </a>
                </div>
                <div className="text-large" style={{ marginBottom: 10 }}>
                  <span>
                    <strong>Step 2: </strong>
                  </span>
                  <span>Sign in to the app with your {appName} account credentials</span>
                </div>
                <div className="text-large">
                  <span>
                    <strong>Step 3: </strong>
                  </span>
                  <span>Enjoy your audio!</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }

  renderEpisodes() {
    const {
      soundcastID,
      soundcast,
      episodes,
      likes,
      currentEpisode,
      playing,
      episodeLoading,
      paused,
      soundcastAvailable,
      renderReady,
      disableTracksAttachedContent,
    } = this.state;

    if (soundcastAvailable && renderReady && isEmpty(episodes)) {
      return (
        <div className="col-md-offset-1 col-md-10">
          <EmptyEpisodes className="title-medium">No Tracks</EmptyEpisodes>
        </div>
      );
    }

    return (
      <div className="col-md-offset-1 col-md-10">
        <InfiniteScroll
          pageStart={1}
          initialLoad={false}
          loadMore={this.loadMorePaginatedEpisodes}
          hasMore={this.hasMorePaginatedEpisodes()}
          loader={this.renderPaginatedEpisodesLoader()}
          useWindow={true}>
          {episodes.map((episode, i) => {
            return (
              <EpisodePreview
                key={`${episode.episodeId}-${i}`}
                episode={episode}
                liked={likes.includes(episode.episodeId)}
                userInfo={this.props.userInfo}
                onEpisodePlay={this.onEpisodePlay}
                onEpisodeLike={this.onEpisodeLike}
                currentEpisode={currentEpisode}
                playing={playing}
                loading={isEqual(episodeLoading, episode.episodeId)}
                paused={paused}
                soundcast={soundcast}
                soundcastID={soundcastID}
                audioPlayer={this.audio}
                disableTracksAttachedContent={disableTracksAttachedContent}
              />
            );
          })}
        </InfiniteScroll>
      </div>
    );
  }

  render() {
    const {
      soundcast,
      soundcastID,
      noAccess,
      playlist,
      playerLaunched,
      soundcastAvailable,
      renderReady,
      onlyMobileAccessToTracks = false,
    } = this.state;

    const { title, imageURL, short_description = '' } = soundcast;

    return (
      <FullContentWrapper>
        <SoundwiseHeader />
        <FullContentSection
          className="padding-40px-tb builder-bg xs-padding-20px-tb"
          id="feature-section14"
          background="#f8f8f8">
          {!soundcastAvailable && !renderReady && (
            <LoadingContainer>
              <Loading text="Loading Audio Program" align="center" size={70} fontSize={1.8} />
            </LoadingContainer>
          )}
          {noAccess && this.renderNoAccess()}
          {soundcastAvailable && (
            <MuiThemeProvider>
              <div className="container">
                <div className="row">
                  <SoundcastDetails>
                    <div className="col-lg-offset-1 col-lg-2 col-md-2 col-sm-3 col-xs-12 sm-margin-ten-bottom">
                      <img src={imageURL} alt={title} />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 col-xs-12 text-center sm-margin-ten-bottom">
                      <div className="title-large alt-font sm-section-title-medium xs-title-extra-large text-dark-gray tz-text margin-three">
                        {title}
                      </div>
                      {!isEmpty(short_description) && (
                        <span className="text-medium">{short_description}</span>
                      )}
                    </div>
                  </SoundcastDetails>
                </div>
                {!onlyMobileAccessToTracks && (<div className="row">{this.renderEpisodes()}</div>)}
                {onlyMobileAccessToTracks && (<div className="row">{this.renderMobileAccess()}</div>)}
              </div>
            </MuiThemeProvider>
          )}
        </FullContentSection>

        <AudioPlayer
          playlist={playlist}
          audioElementRef={elem => (this.audio = elem)}
          hideBackSkip={true}
          hideForwardSkip={true}
          onMediaEvent={{
            play: this.recordPlaying,
            pause: this.handlePause,
            ended: this.handleEpisodeEnd,
          }}
          style={{
            display: playerLaunched ? '' : 'none',
            width: '100%',
            bottom: 0,
            position: 'fixed',
            zIndex: 1000,
          }}
        />

        <Footer soundcastID={soundcastID} />
      </FullContentWrapper>
    );
  }
}

const EmptyEpisodes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  height: 200px;
`;

const SoundcastDetails = styled.div`
  @media only screen and (min-width: 992px) {
    display: flex;
    align-items: center;
    padding: 20px 0px;
  }
`;

const EpisodesLoader = styled.div`
  width: 100%;
  background: #fff;
`;

const mapStateToProps = state => {
  const { userInfo, isLoggedIn } = state.user;
  return { userInfo, isLoggedIn };
};

export default SoundcastPlayer = connect(mapStateToProps, null)(SoundcastPlayer);
